import * as Yup from "yup";
import dayjs from "dayjs";

export const applyLeaveValidationSchema = Yup.object().shape({
  companyCode: Yup.number().required("Company Code is required"),
  headerID: Yup.number().required("Header ID is required"),
  requestDate: Yup.string().required("Request Date is required"),
  employeeCode: Yup.number().required("Employee Code is required"),
  prevNoOfDays: Yup.number().typeError("Enter a valid number"),
  reason: Yup.string().required("Reason is required"),
  createUser: Yup.string().required("Create User is required"),
  noOfDays: Yup.number()
    .min(0, "Number of days must be greater than 0")
    .typeError("Enter a valid number")
    .required("Please Select Valid From and To Date"),
  // .test(
  //   "noOfDays",
  //   "Requesting days is more than available limit",
  //   function (value) {
  //     if (this.parent.isPaidLeave === false) {
  //       console.log(this.parent.isPaidLeave);
  //       return true;
  //     }
  //     return value <= this.parent.balanceLeave;
  //   }
  // ),

  leaveCode: Yup.number()
    .min(1, "Select leave type")
    .required("Select leave type"),
  locationCode: Yup.string().required("Location Code is required"),
  imageAttachment: Yup.string(),
  leaveFrom: Yup.string().required("Leave From is required"),
  // leaveTo: Yup.string().required("Leave To is required"),
  leaveTo: Yup.string()
    .required("Leave To is required")
    .test(
      "is-after-leaveFrom",
      "Leave To Date must be after Leave From Date",
      function (value) {
        const { leaveFrom } = this.parent;
        if (!value || !leaveFrom) return true;
        return (
          dayjs(value).isAfter(dayjs(leaveFrom), "day") ||
          dayjs(value).isSame(dayjs(leaveFrom), "day")
        ); // strictly after
      }
    )
    .test(
      "is-not-before-today",
      "Leave To Date cannot be in the past",
      function (value) {
        return value
          ? dayjs(value) //.isAfter(dayjs().subtract(1, "day").endOf("day"))
          : true;
      }
    ),

  details: Yup.array()
    .of(
      Yup.object().shape({
        companyCode: Yup.number().required("Company Code is required"),
        leaveId: Yup.number().required("Leave ID is required"),
        employeeCode: Yup.number().required("Employee Code is required"),
        leaveFrom: Yup.string().required("Leave From is required"),
        leaveTo: Yup.string().required("Leave To is required"),
        noOfDays: Yup.number()
          .min(0, "Number of days must be greater or equal to 0")
          .typeError("Enter a valid number")
          .required("Number of days is required"),
        isHalfDay: Yup.bool(),
        isPaidLeave: Yup.bool(),
        isApproved: Yup.number(),
        approvedBy: Yup.string(),
        approvedDate: Yup.string(),
      })
    )
    .min(1, "At least one leave detail is required")
    .required("Leave details are required")
    .test(
      "paid-leave-balance-check",
      "Requested paid leave exceeds available balance",
      function (details) {
        if (!details || !Array.isArray(details)) return true;

        const { balanceLeave } = this.parent;
        if (balanceLeave == null) return true;

        // Calculate total paid leave days
        const totalPaid = details.reduce((sum, item) => {
          if (!item.isPaidLeave) return sum;
          if (item.isHalfDay) return sum + 0.5;
          return sum + 1;
        }, 0);

        return totalPaid <= balanceLeave;
      }
    ),

  // details: Yup.array()
  //   .of(
  //     Yup.object().shape({
  //       companyCode: Yup.number().required("Company Code is required"),
  //       leaveId: Yup.number().required("Leave ID is required"),
  //       employeeCode: Yup.number().required("Employee Code is required"),
  //       leaveFrom: Yup.string().required("Leave From is required"),
  //       leaveTo: Yup.string().required("Leave To is required"),
  //       noOfDays: Yup.number()
  //         .min(0, "Number of days must be greater or equal to 0")
  //         .typeError("Enter a valid number")
  //         .required("Number of days is required"),
  //       isHalfDay: Yup.bool(),
  //       isPaidLeave: Yup.bool(),
  //       isApproved: Yup.number(),
  //       approvedBy: Yup.string(),
  //       approvedDate: Yup.string(),
  //     })
  //   )
  //   .min(1, "At least one leave detail is required")
  //   .required("Leave details are required"),
});

export const publicHolidayValidationSchema = Yup.object().shape({
  description: Yup.string().required("Holiday Date is required"),
  holidayDate: Yup.string().required("Holiday Name is required"),
  isActive: Yup.bool(),
});

// export const applyLeaveValidationSchemaOld = Yup.object().shape({
//   employeeCode: Yup.number().required("Employee Code is required"),
//   leaveCode: Yup.number()
//     .min(1, "Select leave type")
//     .required("Select leave type"),
//   reason: Yup.string().required("Reason is required"),
//   requestDate: Yup.string().required("Request Date is required"),
//   leaveFrom: Yup.string().required("Leave From is required"),
//   // leaveTo: Yup.string().required("Leave To is required"),
//   leaveTo: Yup.string()
//     .required("Leave To is required")
//     .test(
//       "is-after-effectiveDateFrom",
//       "Leave To Date must be after Leave From Date",
//       function (value) {
//         const { effectiveDateFrom } = this.parent;
//         return value && effectiveDateFrom
//           ? dayjs(value) //.isAfter(dayjs(effectiveDateFrom))
//           : true;
//       }
//     )
//     .test(
//       "is-not-before-yesterday",
//       "Leave To Date cannot be in the past",
//       function (value) {
//         return value
//           ? dayjs(value) //.isAfter(dayjs().subtract(1, "day").endOf("day"))
//           : true;
//       }
//     ),
//   prevNoOfDays: Yup.number().typeError("Enter a valid number"),
//   balanceLeave: Yup.number()
//     .min(0, "Leave balance must be greater than or equal to 0")
//     .typeError("Enter a valid number")
//     .required("Please Select Valid From and To Date"),
//   // leaveType: Yup.string().required("Leave Type is required"),
//   isPaidLeave: Yup.bool(),
//   isApproved: Yup.number(),
//   imageAttachment: Yup.string(),
//   noOfDays: Yup.number()
//     .min(0, "Number of days must be greater ? equal to 0")
//     .typeError("Enter a valid number")
//     .required("Please Select Valid From and To Date")
//     .test(
//       "noOfDays",
//       "Requesting days is more than available limit",
//       function (value) {
//         if (this.parent.isPaidLeave === false) {
//           console.log(this.parent.isPaidLeave);
//           return true;
//         }
//         return value <= this.parent.balanceLeave;
//       }
//     ),
// });
